export type MileageScopedEditSection =
  | 'basicInformation'
  | 'tripInformation'
  | 'mileageInformation'
  | 'budgetAndProject'
  | 'costCenters'
  | 'additionalInformation'
  | 'files'

const MILEAGE_SCOPED_EDIT_SECTIONS: ReadonlySet<string> = new Set<MileageScopedEditSection>([
  'basicInformation',
  'tripInformation',
  'mileageInformation',
  'budgetAndProject',
  'costCenters',
  'additionalInformation',
  'files',
])

export const isMileageScopedEditSection = (section: string): section is MileageScopedEditSection =>
  MILEAGE_SCOPED_EDIT_SECTIONS.has(section)
